import { ArrowRight, ImageOff } from "lucide-react";
import { Link } from "react-router-dom";
import { GetImageUrl } from "../../helpers/GetImageUrl";

const ServiceCard = ({ service, className = "" }) => {
  return (
    <Link
      to={`/services/${service.slug}`}
      className={`group block h-full ${className}`}
    >
      <article
        className="
          h-full
          flex
          flex-col
          bg-white
          rounded
          border
          border-slate-300
          overflow-hidden
          transition-all
          duration-300
          hover:shadow-lg
        "
      >
        <div className="relative w-full overflow-hidden bg-slate-100">
          {service.sectionImage || service.bannerImage ? (
            <img
              src={GetImageUrl(service.sectionImage || service.bannerImage)}
              alt={
                service.sectionAlt ||
                service.bannerAlt ||
                service.bannerTitle ||
                "Service"
              }
              loading="lazy"
              decoding="async"
              className="block h-auto w-full object-contain transition-transform duration-500 group-hover:scale-[1.02]"
              onError={(event) => {
                event.currentTarget.src =
                  "https://placehold.co/591x240?text=No+Image";
              }}
            />
          ) : (
            <div className="flex w-full aspect-[591/240] items-center justify-center">
              <ImageOff className="h-20 w-20 text-slate-300" />
            </div>
          )}
        </div>

        {/* Content */}
        <div className="flex flex-col flex-1 p-3 sm:p-4">
          <h3 className="mt-1 text-sm sm:text-base font-bold text-slate-900 leading-snug line-clamp-2 min-h-[42px]">
            {service.bannerTitle}
          </h3>

          <p className="mt-2 text-xs sm:text-sm text-slate-500 leading-relaxed line-clamp-2 min-h-[40px]">
            {service.bannerSubtitle ||
              service.shortDescription ||
              "Professional security and IT services tailored to your requirements."}
          </p>

          <div className="mt-auto pt-3">
            <div className="p-2 flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white rounded transition-colors">
              <span className="text-xs sm:text-sm font-semibold">
                View Details
              </span>

              <ArrowRight
                size={15}
                className="transition-transform group-hover:translate-x-1"
              />
            </div>
          </div>
        </div>
      </article>
    </Link>
  );
};

export default ServiceCard;